<template>
    <div class="shortcut-container">
        <div class="circle-shortcut"
            :class="{ activated: oneToggle, deactivated: !oneToggle, disabled: checkLayerDisable(0)}"
            @click="!checkLayerDisable(0) && toggleBtn(0, !oneToggle) && (oneToggle = !oneToggle)">{{ btnLabels[0] }}</div>
        <div class="circle-shortcut"
            :class="{activated: twoToggle, deactivated: !twoToggle, disabled: checkLayerDisable(1)}"
            @click="!checkLayerDisable(1) && toggleBtn(1, !twoToggle) && (twoToggle = !twoToggle)">{{ btnLabels[1] }}</div>
        <div class="circle-shortcut"
            :class="{activated: threeToggle, deactivated: !threeToggle, disabled: checkLayerDisable(2)}"
            @click="!checkLayerDisable(2) && toggleBtn(2, !threeToggle) && (threeToggle = !threeToggle)">{{ btnLabels[2] }}</div>
        <div class="circle-shortcut"
            :class="{activated: fourToggle, deactivated: !fourToggle, disabled: checkLayerDisable(3)}"
            @click="!checkLayerDisable(3) && toggleBtn(3, !fourToggle) && (fourToggle = !fourToggle)">{{ btnLabels[3] }}</div>
        <div class="circle-shortcut"
            :class="{activated: fiveToggle, deactivated: !fiveToggle, disabled: checkLayerDisable(4)}"
            @click="!checkLayerDisable(4) && toggleBtn(4, !fiveToggle) && (fiveToggle = !fiveToggle)">{{ btnLabels[4] }}</div>
        <div v-if="btnLabels.length > 5" class="circle-shortcut"
            :class="{activated: sixToggle, deactivated: !sixToggle, disabled: checkLayerDisable(5)}"
            @click="!checkLayerDisable(5) && toggleBtn(5, !sixToggle) && (sixToggle = !sixToggle)">{{ btnLabels[5] }}</div>
        <div v-if="btnLabels.length > 6" class="circle-shortcut"
            :class="{activated: sevenToggle, deactivated: !sevenToggle, disabled: checkLayerDisable(6)}"
            @click="!checkLayerDisable(6) && toggleBtn(6, !sevenToggle) && (sevenToggle = !sevenToggle)">{{ btnLabels[6] }}</div>
    </div>
</template>

<script>
export default {
  name: 'MMP_ANSI_LayerShortcuts',
  props: ['btnLabels', 'btnLayers', 'activeLayers', 'ansiLayersButtonCtrl'],
  data() {
    return {
        oneToggle: false,
        twoToggle: false,
        threeToggle: false,
        fourToggle: false,
        fiveToggle: false,
        sixToggle: false,
        sevenToggle: false
    }
  },
  methods: {
    checkLayerDisable(index) {
        if (this.ansiLayersButtonCtrl.length == 0) {
            return;
        }
        let label = this.btnLabels[index]
        let shortcutLayers = this.btnLayers[label]

        let ansiDLL = this.$parent?.$parent?.$refs?.ansiLayers?.$refs?.ansiDLL;

        if (!ansiDLL) {
            return false;
        }

        return shortcutLayers.some(layerName => {
            let layer = this.ansiLayersButtonCtrl.find(l => l.name === layerName);
            if (layer) {
                return ansiDLL.checkLayerDisable(layer.name, layer.zoomControl, layer.minZoom);
            }
            return false;
        });
    },
    toggleBtn(index, param) {
        let label = this.btnLabels[index]
        let shortcutLayers = this.btnLayers[label]
        shortcutLayers.forEach(layerName => {
            this.toggleLayer(layerName, param)
        })
    },
    toggleLayer(layerName, bool) {
        // bool indicates whether or not the button is on / off after the user clicks the button
        if (bool) {
            if (!this.activeLayers.find(layer => layer.get('name') == layerName)) {
                // if button is turned on and layer is not already visible, toggle the layer on
                this.$emit('toggleLayer', layerName) 
            }
        } else {
            if (this.activeLayers.find(layer => layer.get('name') == layerName)) {
                // if button was toggled off and the layer is visible, toggle the layer off
                this.$emit('toggleLayer', layerName) 
            }
        }
    },
  },
  watch: {
    activeLayers: function(newValue) {
        const layerNames = new Set(newValue.map(layer => layer.get('name')));

        // First Button
        let label = this.btnLabels[0]
        let shortcutLayers = this.btnLayers[label]
        this.oneToggle = shortcutLayers.every(layerName => layerNames.has(layerName));

        // Second Button
        label = this.btnLabels[1]
        shortcutLayers = this.btnLayers[label]
        this.twoToggle = shortcutLayers.every(layerName => layerNames.has(layerName));

        // Third Button
        label = this.btnLabels[2]
        shortcutLayers = this.btnLayers[label]
        this.threeToggle = shortcutLayers.every(layerName => layerNames.has(layerName));

        // Fourth Button
        label = this.btnLabels[3]
        shortcutLayers = this.btnLayers[label]
        this.fourToggle = shortcutLayers.every(layerName => layerNames.has(layerName));

        // Fifth Button
        label = this.btnLabels[4]
        shortcutLayers = this.btnLayers[label]
        this.fiveToggle = shortcutLayers.every(layerName => layerNames.has(layerName));

        // Sixth Button
        if (this.btnLabels.length > 5) {
            label = this.btnLabels[5]
            shortcutLayers = this.btnLayers[label]
            this.sixToggle = shortcutLayers.every(layerName => layerNames.has(layerName));
        }

        // Seventh Button
        if (this.btnLabels.length > 6) {
            label = this.btnLabels[6]
            shortcutLayers = this.btnLayers[label]
            this.sevenToggle = shortcutLayers.every(layerName => layerNames.has(layerName));
        }
    }
  }
}
</script>

<style scoped>
.shortcut-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    gap: 10px;
}
.circle-shortcut {
    height: 34px;
    width: 34px;
    border-radius: 17px;
    border: 1px solid rgba(6, 60, 109, 0.18);
    color: #063c6d;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8.5px;
    font-weight: 600;
    padding-top: 3px;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.circle-shortcut.deactivated {
    background-color: #ffffff;
    color: #063c6d;
    border-color: rgba(6, 60, 109, 0.18);
}
.circle-shortcut.deactivated:not(.disabled):hover {
    background-color: rgba(6, 60, 109, 0.06);
    border-color: rgba(6, 60, 109, 0.4);
}
.circle-shortcut.activated {
    background-color: #063c6d;
    color: #ffffff;
    border-color: #063c6d;
}
.circle-shortcut.activated:not(.disabled):hover {
    background-color: #0a4f8f;
    border-color: #0a4f8f;
}
.fa-1-5x {
    font-size: 1.5em;
}
.disabled {
    pointer-events: none;
    opacity: 0.4;
}
</style>